<div>
    <div class="top">
        <app-custom-date-filter (dateSeletected)="setDateFilterPeriods($event)"></app-custom-date-filter>
        <h2>Total: {{totalHours}}</h2>
    </div>
    <app-track-list [trackEntries]="timeTracks()" [projects]="projects()" [tags]="tags()" [users]="users()"
        [showUsers]="true"></app-track-list>
</div>
